import { useState } from "react";
import { useApp } from "@/store/AppStore";
import { uid } from "@/utils/format";

const QuickPromotion = () => {
  const { data, addPromotion, deletePromotion } = useApp();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [discount, setDiscount] = useState(10);
  const [feedback, setFeedback] = useState("");

  const create = () => {
    if (!title.trim()) {
      setFeedback("Escribe un título para la promoción.");
      return;
    }
    const now = new Date();
    const end = new Date();
    end.setDate(now.getDate() + 15);
    addPromotion({
      id: uid("promo"),
      title: title.trim(),
      description: description.trim() || "Promoción especial para tu red de asesores.",
      discountPct: discount,
      startDate: now.toISOString(),
      endDate: end.toISOString(),
      createdAt: now.toISOString(),
    });
    setTitle("");
    setDescription("");
    setDiscount(10);
    setFeedback("Promoción creada y notificada a los asesores.");
    setTimeout(() => setFeedback(""), 2200);
  };

  return (
    <div className="glass-panel rounded-lg p-4 md:p-5">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-8 h-8 rounded-md bg-secondary-500/25 text-secondary-200 flex items-center justify-center">
          <i className="ri-megaphone-line" />
        </span>
        <h3 className="editable-title text-base font-bold">Diseñador de Promociones</h3>
      </div>
      <p className="text-[11px] text-foreground-500 mb-3">
        Crea ofertas masivas que se notifican al instante en la pantalla de los asesores.
      </p>

      <div className="space-y-3">
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Ej: Combo Nutrilite Doble X + Proteína"
          className="w-full bg-background-100/70 border border-background-300/50 rounded-md px-3 py-2 text-sm text-foreground-950 placeholder:text-foreground-500 outline-none focus:border-accent-500/50"
        />
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value.slice(0, 500))}
          rows={2}
          maxLength={500}
          placeholder="Descripción breve de la oferta..."
          className="w-full bg-background-100/70 border border-background-300/50 rounded-md px-3 py-2 text-sm text-foreground-950 placeholder:text-foreground-500 outline-none focus:border-accent-500/50 resize-none"
        />
        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
          <label className="text-[11px] font-semibold text-foreground-600 whitespace-nowrap">
            Descuento: <span className="text-accent-300">{discount}%</span>
          </label>
          <input
            type="range"
            min={1}
            max={50}
            value={discount}
            onChange={(e) => setDiscount(Number(e.target.value))}
            className="flex-1 accent-[oklch(0.68_0.145_234)] cursor-pointer"
          />
          <button
            onClick={create}
            className="px-4 py-2 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer"
          >
            Publicar
          </button>
        </div>
      </div>

      {feedback && (
        <p className="text-[11px] text-secondary-200 mt-3 flex items-center gap-1.5 animate-fade-up">
          <i className="ri-notification-3-line" /> {feedback}
        </p>
      )}

      {data.promotions.length > 0 && (
        <div className="mt-4 pt-3 border-t border-accent-500/15 space-y-2">
          {data.promotions.slice(0, 3).map((p) => (
            <div
              key={p.id}
              className="flex items-center justify-between gap-2 rounded-md bg-background-200/40 px-3 py-2"
            >
              <div className="min-w-0">
                <p className="text-xs font-semibold text-foreground-900 truncate">{p.title}</p>
                <p className="text-[10px] text-foreground-500">-{p.discountPct}% descuento</p>
              </div>
              <button
                onClick={() => deletePromotion(p.id)}
                className="w-7 h-7 flex items-center justify-center rounded-md text-foreground-500 hover:text-accent-300 hover:bg-background-300/40 cursor-pointer shrink-0"
                aria-label="Eliminar promoción"
              >
                <i className="ri-delete-bin-line text-sm" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuickPromotion;